/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
// src/components/SectionMeta/index.js
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const SectionHeaderRow = styled.div`
   width: 100%;
   display: flex;
   align-items: flex-end;
   justify-content: space-between;
   gap: 12px;
   flex-wrap: wrap;
`;

const MetaWrap = styled.div`
   display: flex;
   align-items: center;
   justify-content: flex-end;
   gap: 8px;
   flex-wrap: wrap;
`;

const MetaItem = styled.div`
   display: inline-flex;
   align-items: baseline;
   gap: 6px;
   padding: 6px 10px;
   border-radius: 999px;

   border: 1px solid
      ${({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.08)'};
   background: ${({ theme }) => theme?.colors?.surface ?? '#fff'};
   box-shadow: ${({ theme }) =>
      theme?.shadows?.xs ?? '0 1px 2px rgba(0,0,0,0.04)'};
`;

const MetaLabel = styled.span`
   font-size: 12px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
`;

const MetaValue = styled.span`
   font-size: 12px;
   font-weight: 700;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
`;

export default function SectionMeta({ items = [] }) {
   const safe = Array.isArray(items)
      ? items.filter((it) => it && (it.label || it.value || it.value === 0))
      : [];

   if (!safe.length) return null;

   return (
      <MetaWrap aria-label="Metadados">
         {safe.map((it) => (
            <MetaItem key={String(it.key ?? it.label)}>
               {it.label ? <MetaLabel>{it.label}</MetaLabel> : null}
               <MetaValue>{it.value ?? '-'}</MetaValue>
            </MetaItem>
         ))}
      </MetaWrap>
   );
}

SectionMeta.propTypes = {
   items: PropTypes.arrayOf(
      PropTypes.shape({
         key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
         label: PropTypes.string,
         value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.node,
         ]),
      })
   ),
};
